import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

import {
  READING_EXERCISE_GOAL_FLUENCY,
  READING_EXERCISE_GOAL_MEANING,
  READING_EXERCISE_GOAL_ASSESSMENT,
  READING_EXERCISE_GOALS_DISPLAY_NAME,
} from '../../constants';

export default function UseReadingExerciseAsDialog({isOpen, onClose, selectedValue}) {
  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={isOpen}>
      <DialogTitle>How will you use this book?</DialogTitle>
      <List sx={{pt: 0}}>
        <ListItem button onClick={() => handleListItemClick(READING_EXERCISE_GOAL_FLUENCY)}>
          <ListItemText primary={READING_EXERCISE_GOALS_DISPLAY_NAME[READING_EXERCISE_GOAL_FLUENCY]} />
        </ListItem>
        <ListItem button onClick={() => handleListItemClick(READING_EXERCISE_GOAL_MEANING)}>
          <ListItemText primary={READING_EXERCISE_GOALS_DISPLAY_NAME[READING_EXERCISE_GOAL_MEANING]} />
        </ListItem>
        <ListItem button onClick={() => handleListItemClick(READING_EXERCISE_GOAL_ASSESSMENT)}>
          <ListItemText primary={READING_EXERCISE_GOALS_DISPLAY_NAME[READING_EXERCISE_GOAL_ASSESSMENT]} />
        </ListItem>
      </List>
    </Dialog>
  );
}
